import {Injectable} from '@angular/core';
import {loadModules} from 'esri-loader';
/* eslint-disable @typescript-eslint/no-explicit-any */
@Injectable({
    providedIn: 'root'
})
export class ArcgisGeometryOverride {
    private geometryServicePrototype: any;

    constructor() {
        loadModules(['esri/tasks/GeometryService', 'esri/geometry/geometryEngine', 'esri/geometry/projection']).then(
            ([GeometryService, geometryEngine, projection]) => {
                this.geometryServicePrototype = GeometryService.prototype;
                this.overrideProjectMethod(projection);
                this.overrideLengthsMethod(geometryEngine);
                this.overrideLabelPointsMethod();
            }
        );
    }
    private overrideProjectMethod(projection: any): void {
        if (typeof this.geometryServicePrototype.project === 'function') {
            projection.load().then(() => {
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                this.geometryServicePrototype.project = (a: any, b: any, c: any, d?: any) => {
                    if (a.outSR) {
                        b(projection.project(a.geometries, a.outSR));
                    } else {
                        c(projection.project(a, b));
                    }
                };
            });
        }
    }

    private overrideLengthsMethod(geometryEngine: any): void {
        if (typeof this.geometryServicePrototype.lengths === 'function') {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            this.geometryServicePrototype.lengths = (a: any, b: any, c: any) => {
                const geometry1 = {
                    x: a.polylines[0].paths[0][0][0],
                    y: a.polylines[0].paths[0][0][1],
                    spatialReference: a.polylines[0].spatialReference
                };

                const geometry2 = {
                    x: a.polylines[0].paths[0][1][0],
                    y: a.polylines[0].paths[0][1][1],
                    spatialReference: a.polylines[0].spatialReference
                };

                const distanceResult = geometryEngine.distance(geometry1, geometry2, 'meters');

                b({lengths: [distanceResult]});
            };
        }
    }

    private overrideLabelPointsMethod(): void {
        if (typeof this.geometryServicePrototype.labelPoints === 'function') {
            this.geometryServicePrototype.labelPoints2 = this.geometryServicePrototype.labelPoints;
            this.geometryServicePrototype.labelPoints = function (geometries: any, callback: any, c?: any) {
                return this.labelPoints2(geometries, callback, c);
            };
        }
    }
}
